module.exports = __webpack_public_path__ + "static/img/five.30fd9bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/AtomicChain/assets/personalIntroduction/five.png
// module id = tnv+
// module chunks = 3